import { render } from "./EnvoiRecapEmailView.vue?vue&type=template&id=5fdc62b8&scoped=true"
import script from "./EnvoiRecapEmailView.vue?vue&type=script&lang=js"
export * from "./EnvoiRecapEmailView.vue?vue&type=script&lang=js"

import "./EnvoiRecapEmailView.vue?vue&type=style&index=0&id=5fdc62b8&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdc62b8"]])

export default __exports__